(function ($) {
    fn_nl_lib_anchor();

    $(".lib--parallax").find("img:not(.lazyload)").parent().parallax();

    $(document).on('lazybeforeunveil', '.lazyload', function (e) {
        if ($(e.target).parent().hasClass("lib--parallax")) {
            $(e.target).parent().parallax();
        }
        $(e.target).one('load', function () {
            if ($(this).parent().hasClass("lib--lazyload")) {
                $(this).parent().removeClass("lib--lazyload").addClass("lib--lazyloaded");
            }
        });
    });

    nl_lib_dialog.init(function () {
        $(document).find(".lib--dialog .part_ui_btn").nl_lib_ripple();
    });
    $("[data-switch]").nl_lib_switch();
    $(".part_ui_btn").nl_lib_ripple();

    var picture = document.createElement('picture'),
            strObj = '' + picture;
    if (strObj.indexOf("HTMLPictureElement") === -1 && !$("html").hasClass("ie"))
    {
        $.getScript($cdnjs.picturefill);
    }
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
        $html.addClass("ie11");
    }



    if ($("form").length) {
        setTimeout(function () {
            $("form").append('<input name="antispam" value="antispam" type="hidden" />');
        }, 2500);
    }
})(jQuery);

var recountColors = function ($product) {
    // vypocet vsech barev
    var totalColors = 0;
    $product.find("[data-color-checkbox]:checked").each(function (index, item) {
        var $item = $(item);
        if ($item.val() === 'other') {
            totalColors += parseInt($('[data-other-color-count]').val());
        } else {
            totalColors++;
            if ($(item).data('double')) {
                totalColors++;
            }
        }
    });

    // přidává + 1 barvu na blokr navic
    if ($product.find("[data-additional-item-checkbox][value=3]").prop('checked')) {
        totalColors++;
    }

    // nastaveni poctu v inputu
    totalColors === 0 ? $product.find("[data-color-count]").val("") : $product.find("[data-color-count]").val(totalColors);
};